import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { useTranslation } from 'react-i18next';

import GlobalSettingsPage from './GlobalSettingsPage';
import DataPolicyPage from './DataPolicyPage';

export default function SystemSettingsPage() {
  const { t } = useTranslation();
  const [tab, setTab] = useState(0);

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 2 }}>
        <Tab label={t('settings.tabs.global', 'Global')} />
        <Tab label={t('settings.tabs.dataPolicy', 'Data Policy')} />
      </Tabs>

      {tab === 0 && <GlobalSettingsPage />}
      {tab === 1 && <DataPolicyPage />}
    </Box>
  );
}
